import { CSSProperties } from 'react';
import { Theme } from '@mui/material/styles';
import { BG_COLOR_KEY_MAPPING } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/ColorKeyPerMatch/constants';

const { dark_amber, dark_green, dark_grey, red } = BG_COLOR_KEY_MAPPING;

export const COLOR_KEY_DATA: { label: string; styles: (theme: Theme) => CSSProperties }[] = [
  {
    label: 'Exact Match',
    styles: (theme) => dark_green.styles(theme),
  },
  {
    label: 'Partial Match',
    styles: (theme) => dark_amber.styles(theme),
  },
  {
    label: 'No Match',
    styles: (theme) => red.styles(theme),
  },
  {
    label: 'NA',
    styles: (theme) => dark_grey.styles(theme),
  },
];
